export default __webpack_public_path__ + "static/media/empty.8546675f.png";